function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.3022 12H1.69772C1.31231 12 1 11.6669 1 11.2561V1.74389C1 1.33297 1.31231 1 1.69772 1H14.3022C14.6876 1 15 1.33297 15 1.74389V11.2561C15 11.6669 14.6876 12 14.3022 12Z",
  stroke: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.00002 5.8125C5.69048 5.8125 6.25 5.25276 6.25 4.56248C6.25 3.8722 5.69044 3.3125 5.00002 3.3125C4.3097 3.3125 3.75 3.87211 3.75 4.56248C3.75 5.25285 4.30965 5.8125 5.00002 5.8125Z",
  stroke: "white",
  strokeWidth: 1.5
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 9.0625V8.19275C3.5 7.56846 4.17158 7.0625 5 7.0625C5.82853 7.0625 6.5 7.56846 6.5 8.19275V9.0625",
  stroke: "white",
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.5 5.06346H12.5H9.5Z",
  fill: "#D9D9D9"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 5.06346H12.5",
  stroke: "white",
  strokeLinecap: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.5 8.06346H12.5H9.5Z",
  fill: "#D9D9D9"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 8.06346H12.5",
  stroke: "white",
  strokeLinecap: "round"
});
function SvgViewId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewId);
export default __webpack_public_path__ + "static/media/view-id.d101c4b5.svg";
export { ForwardRef as ReactComponent };